import MyData from './MyData';

export default MyData;